import BraRecommendationFinalContainer from './DressToolFinalPage';

export default BraRecommendationFinalContainer;